import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import "./IncomingCallPopup.css";

export default function IncomingCallPopup({ call, onAccept, onReject }) {
  const [callerName, setCallerName] = useState("Loading...");

  useEffect(() => {
    console.log("📞 Incoming call object:", call);

    if (!call) return;

    // Try all possible fields
    const callerUid =
      call.from ||
      call.callerId ||
      call.callerUID ||
      call.uid ||
      null;

    console.log("👤 Resolved caller UID:", callerUid);

    if (!callerUid) {
      setCallerName("Unknown");
      return;
    }

    const loadName = async () => {
      try {
        const snap = await getDoc(doc(db, "users", callerUid));
        if (snap.exists()) {
          setCallerName(snap.data().name || "Unknown");
        } else {
          setCallerName("Unknown");
        }
      } catch (e) {
        console.error("Name fetch failed", e);
        setCallerName("Unknown");
      }
    };

    loadName();
  }, [call]);

  if (!call) return null;

  return (
    <div className="incoming-call-overlay">
      <div className="incoming-call-box">
        <h3>📞 Incoming {call.type === "video" ? "Video" : "Audio"} Call</h3>

        <p className="caller-name">{callerName}</p>

        <div className="call-actions">
          <button className="reject-btn" onClick={onReject}>Reject</button>
          <button
            className="accept-btn"
            onClick={() => {
              if (call.type === "audio") {
                onAccept("audio");
              } else {
                onAccept("video");
              }
            }}
          >
            Accept
          </button>
         </div>
      </div>
    </div>
  );
}
